const breakPoint = 767;
// let resizeFlag   = false;
let windowWidth  = window.innerWidth;
// let windowHeight = window.innerHeight;
// let windowWidthJ = $(window).width();





// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^=#]").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};



// ------------------------------------------------------------------------
// fadeItem
// ----- BOTH
// ------------------------------------------------------------------------
const fadeItem = () => {
  $(window).on("scroll load", function (){
    $(".anim").each(function(){
      var imgPos = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > imgPos - windowHeight + windowHeight/10){
        $(this).addClass("fadein");
      } else {
        return;
      }
    });
  });
};



// ------------------------------------------------------------------------
// mobileMenu
// ----- BOTH
// ------------------------------------------------------------------------
const mobileMenu = () => {
  $('.st-Header_Hamburger > button, .st-Header_Slide_Close').on('click', function() {
    $(this).toggleClass("opened");
    $(this).parent().toggleClass("opened");
    $(".st-Header_Slide").toggleClass("menu_open");
    $(".st-Header_Slide_Inner").toggleClass("menu_open");
  });
};



// ------------------------------------------------------------------------
// scrollStar
// ----- BOTH
// ------------------------------------------------------------------------
const scrollStar = () => {
  $(window).on('scroll', function(){
    var scrollTop = $(window).scrollTop();
    var bgPosition = scrollTop / 20;
    if(bgPosition){
      // $("#style").html('body:after{background-position: center top -'+ bgPosition + 'px; }');
      if(scrollTop > 300){
        $("#style").html('body:after{opacity: 1;background-position: center top -'+ bgPosition + 'px; }');
      }else{
        $("#style").html('body:after{opacity: 0;background-position: center top -'+ bgPosition + 'px; }');
      }
    }
  });
};

// preload
const preload = () =>{
  $(window).on('load' , function() {
    $("body").removeClass("preload");
    $(".idx-Main").addClass("loaded");
  });
};

// ------------------------------------------------------------------------
// js-Animation
// ------------------------------------------------------------------------
const scrollAnimation = () => {
  let winScroll = $(window).scrollTop();
  let winHeight = $(window).height();
  // js-Animation
  $('.js-Animation').each(function(){
    let target = $(this);
    if(windowWidth > breakPoint){
      if(target.offset().top < winScroll + (winHeight * .9)) {
        target.addClass('animated');
      }
    }else{
      if(target.offset().top < winScroll + (winHeight * .9)) {
        target.addClass('animated');
      }
    }
  });
};

// ------------------------------------------------------------------------
// swiper
// ------------------------------------------------------------------------
const movieSwiper = () => {
  const swiper = new Swiper('.swiper', {
    // Optional parameters
    loop: true,
    allowTouchMove: true,
    loopAdditionalSlides: 1,
    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints:{
      768: {
        slidesPerView: 2,
        loopAdditionalSlides: 2,
        grabCursor: true,

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },
    },
  });
};

/*-------------------------------------------------------------------*/
/* movieモーダル */
/*-------------------------------------------------------------------*/
// movie
const showMovie = () => {
  // const $modal = $('#movie-Stage');
  const $content = $('#movie-Iframe');
  // open
  $('body').on('click', '.js-Youtube', function(){
    const dataID = $(this).attr('data-youtube');
    console.log(dataID);
    $('#movie-Stage').css({'opacity':'0','display':'block'}).stop().animate({'opacity':'1','width':100+'%','height':100+'vh','top':0,'left':0},300,'easeOutQuart',function(){
      //iframe append
      $content.append('<iframe width="900" height="506" src="https://www.youtube.com/embed/'+dataID+'?rel=0&amp;autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen" frameborder="0"></iframe>');
      // // fadeIn
      // $modal.stop().fadeIn(400);
      return false;
    });
  });
  //close
  $('#movie-Close,#movie-Iframe').on('click', function(){

    $('#movie-Stage').css({'opacity':'1'}).stop().animate({'opacity':'0'},300,'easeOutQuart',function(){
      $('#movie-Stage').css({'display':'none'});
      $content.children('iframe').remove();
    });
  });
};

/*-------------------------------------------------------------------*/
/* movieモーダル */
/*-------------------------------------------------------------------*/
// movie
const bnr_modal = () => {
  if($('div').hasClass('afterparty_modal')){
    const $content = $('#afterparty_modal');
    $($content).fadeIn();
    const $contentOverlay = $('#afterparty_modal_overlay');
    const $contentHamburger = $('#afterparty_modal_hamburger');
    $($contentOverlay).on('click', function(){
      $($content).fadeOut();
    });
    $($contentHamburger).on('click', function(){
      $($content).fadeOut();
    });
  }
};

export {
  preload,
  anchorLink,
  fadeItem,
  mobileMenu,
  scrollStar,
  scrollAnimation,
  movieSwiper,
  showMovie,
  bnr_modal,
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js